/**
 * Generated by scripts/build-manifest.mjs. Do not edit by hand.
 *
 * Structure only: which terms have exercises, how many rungs each has, and what they are
 * called. Everything the shell needs before anything is on screen. The prose lives in
 * ./notes.ts, which the drawer imports on demand, and the checks and solutions live in the
 * exercise sets. Run `npm run build:manifest` after changing an exercise set;
 * `npm run verify` fails if this has drifted.
 */

export interface ManifestRung {
  id: string;
  role: 'recognize' | 'guided' | 'implement' | 'break' | 'apply' | 'articulate';
  title: string;
  kind: 'choice' | 'expr' | 'code' | 'reveal';
  /** Which lap this rung belongs to. */
  lang: 'js' | 'ts';
}

export interface ManifestEntry {
  termId: string;
  rungs: ManifestRung[];
}

export const manifest: ManifestEntry[] = [
  {
    "termId": "function",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which one is a function in the strict sense?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "diagnose",
        "role": "recognize",
        "title": "Which promise does each one break?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Relate every input to exactly one output",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "repair",
        "role": "apply",
        "title": "Repair three near-misses",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "arity",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does fn.length report?",
        "kind": "expr",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Name an arity",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Predict where currying goes wrong",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "curry-by-length",
        "role": "break",
        "title": "Watch auto-currying read fn.length and get it wrong",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "lambda",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What makes something a lambda?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "guided",
        "role": "guided",
        "title": "Inline the named callbacks",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Pass functions around without naming them",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "higher-order-functions-hof",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Write filter and is",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Write once",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "both-shapes",
        "role": "apply",
        "title": "Take one, return one, and do both at once",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "closure",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A counter with private state",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "predict",
        "role": "recognize",
        "title": "Predict what the reporters say",
        "kind": "expr",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Fix the loop that captured the wrong thing",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "instances",
        "role": "apply",
        "title": "Two accounts that cannot reach each other",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "predicate",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Combine predicates",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Build a filter from the pieces",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "combine",
        "role": "apply",
        "title": "Combine predicates into a spec",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "pure-function",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which one is pure?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Purify addItem",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "purify",
        "role": "apply",
        "title": "Purify three functions",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "thunk",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Defer the work",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Compute it at most once",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "once",
        "role": "apply",
        "title": "A thunk recomputes, unless you make it not",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "partial-function",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which of these are partial?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Find the inputs that break it",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "widen",
        "role": "apply",
        "title": "Survey three functions, then make them total",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "total-function",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Make three functions total",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What should the empty case give?",
        "kind": "expr",
        "lang": "js"
      },
      {
        "id": "prove-it",
        "role": "apply",
        "title": "Prove totality across a domain",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "trampoline",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Bounce instead of recursing",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Why does a trampoline help?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Show the stack running out, then survive it",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "partial-application",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Write partial",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Build fivePlus",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "versus",
        "role": "apply",
        "title": "Partial application against currying, side by side",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "currying",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Spot the curried functions",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Write curry2",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Go point-free",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "point-free-pipeline",
        "role": "apply",
        "title": "Curry three, then drop every argument",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "auto-currying",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Curry any function automatically",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Where does auto-currying stop working?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "arity",
        "role": "recognize",
        "title": "Predict what arity each definition reports",
        "kind": "expr",
        "lang": "js"
      },
      {
        "id": "groupings",
        "role": "apply",
        "title": "Every grouping reaches the same answer",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "function-composition",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Write compose and pipe",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Read a name out of a record",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "laws",
        "role": "apply",
        "title": "compose, pipe, and the laws that hold between them",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "point-free-style",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which definitions are point-free?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Remove the arguments",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "judgement",
        "role": "apply",
        "title": "Go point-free one way, and back the other",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "functional-combinator",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "The classic combinators",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What disqualifies a combinator?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "identities",
        "role": "implement",
        "title": "Write S, K, I and check that S(K)(K) is I",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "continuation",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Convert to continuation-passing style",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What is the continuation?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "name-it",
        "role": "apply",
        "title": "Write the continuation down, then intercept one",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "sequence",
        "role": "apply",
        "title": "Run a list of continuation-passing steps in order",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "lazy-evaluation",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "An infinite list you can take from",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Filter an endless list",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "pull",
        "role": "apply",
        "title": "Only do the work that is asked for",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "io",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "An IO that does nothing until you run it",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Describe a program without running it",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "reuse",
        "role": "apply",
        "title": "Build the effect once, run it as often as you like",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "algebraic-effects",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Write the handler",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does the program know?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "swap",
        "role": "apply",
        "title": "One program, two handlers",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "side-effects",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Spot every effect",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Push the effects to the edge",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "reads",
        "role": "apply",
        "title": "Reading is an effect too",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "value",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What can be a value?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Treat a function as data",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "expressions",
        "role": "apply",
        "title": "Turn statements into expressions",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "constant",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does const actually promise?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Freeze all the way down",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "prove-it",
        "role": "break",
        "title": "Prove that const promises nothing about the value",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "use-frozen",
        "role": "apply",
        "title": "Freeze a whole config and use it inline",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "constant-function",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Write constant",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Use it to blank a list",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "use-it",
        "role": "apply",
        "title": "Where a function that ignores its argument earns its keep",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "referential-transparency",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which calls can be replaced by their result?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Make the calls substitutable",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "the-test",
        "role": "apply",
        "title": "Write the substitution test",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "repair-more",
        "role": "apply",
        "title": "Repair two calls that are not substitutable",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "equational-reasoning",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which rewrites are safe?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "guided",
        "role": "guided",
        "title": "Rewrite a pipeline step by step",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "needs-purity",
        "role": "break",
        "title": "Find the input where a safe rewrite stops being safe",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "fuse",
        "role": "apply",
        "title": "Fuse a pipeline and check it still agrees",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "idempotence",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which of these are idempotent?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Make normalizeEmail idempotent",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "classify",
        "role": "apply",
        "title": "Tell idempotent apart from safe to repeat",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "make-it-so",
        "role": "apply",
        "title": "Make a normalizer idempotent",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "memoization",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Cache by argument",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Watch memoization lie",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "cache",
        "role": "apply",
        "title": "Cache per argument, including the falsy answers",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "contracts",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Wrap a function in a contract",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What is a contract for?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "both-ends",
        "role": "apply",
        "title": "Guard both ends, and say what went wrong",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "type-signatures",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which implementation fits the signature?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Write the functions the signatures describe",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "constrains",
        "role": "implement",
        "title": "Write the only function each signature allows",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "algebraic-data-type",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Sum or product?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Count the inhabitants",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "arithmetic",
        "role": "apply",
        "title": "Count the values, and watch the names make sense",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "product-type",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "How many values does this type have?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Build every inhabitant",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "enumerate",
        "role": "apply",
        "title": "List every value a product can take",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "sum-type",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A tagged union with an exhaustive match",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which of these are sum types?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "from-flags",
        "role": "apply",
        "title": "Replace a bag of flags with a sum",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Match on Status exhaustively",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "What the never branch is actually for",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "option",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Some, None, and the three ways out",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Read a nested field safely",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Option<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Falsy is not the same as missing",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "either",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Left, Right, and fold",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "A parse pipeline that reports why it failed",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Either<E, A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "map names only A, so the reason survives",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "lens",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "lens, view, set, over",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Update something nested",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "deep-compose",
        "role": "apply",
        "title": "Compose three lenses to reach three levels down",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "A lens with its types written down",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Read over's return type",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "prism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A prism for integers in strings",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Lens or prism?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Prism<string, number>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Read where the Option is, and is not",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "iso",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Two views of the same thing",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which pairs are isomorphisms?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Iso<[number, number], Point>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Total does not mean lossless",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "traversal",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Focus on many things at once",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "How many does each optic focus on?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Traversal<Player, number>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Read the plural and the singular",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "lambda-calculus",
    "rungs": [
      {
        "id": "guided",
        "role": "guided",
        "title": "Numbers made only of functions",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What is the lambda calculus made of?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "three-rules",
        "role": "implement",
        "title": "Name the three forms, then find the free variables",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "church",
        "role": "implement",
        "title": "succ and add, out of nothing but functions",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "setoid",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Equality you can rely on",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which law does this break?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Setoid<Point>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The type cannot check the laws",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "semigroup",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Three ways to combine two things",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which operations are associative?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Semigroup<number> three times",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "One type, three instances",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "monoid",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A semigroup with a neutral element",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Subtraction is not even a semigroup",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Monoid<A> four times",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The type demands an empty and cannot say which",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "functor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Give Box a lawful map",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "A Maybe that skips missing values",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Break a law on purpose",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "break-composition",
        "role": "break",
        "title": "Break composition while identity still holds",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "The same Box, with the type written down",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Read what map is allowed to change",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "pointed-functor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A functor that knows how to lift",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What is of allowed to do?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "entry-point",
        "role": "apply",
        "title": "Write a pipeline that works for any pointed functor",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Box<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "A generic of cannot have opinions",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "constant-functor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A functor whose map does nothing",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What is Const good for?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "build-view",
        "role": "apply",
        "title": "Build view out of over, using Const",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Const<A, B>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "There is no B to call the function on",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "applicative-functor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Apply a wrapped function to a wrapped value",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Combine two Maybes without unwrapping either",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Box<A> including ap",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "ap is a condition on the receiver",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "lift",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Lift an ordinary function into a container",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does lifting need from the container?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Write liftA2 over Box",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The curry step is what ap needs",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "monad",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "chain for Maybe",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "chain for Array",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Maybe<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Count the layers map leaves behind",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "constant-monad",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A chain that keeps the contents",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "break",
        "role": "break",
        "title": "Show that it is not a lawful monad",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "which-laws",
        "role": "break",
        "title": "Two laws hold, one does not",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "kleisli-composition",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Compose functions that return containers",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Why not ordinary composition?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Write composeK",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "Where ordinary compose would not typecheck",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "comonad",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "extract and extend",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Monad or comonad?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy CoIdentity<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "extend hands over the container, not the value",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "free-monad",
    "rungs": [
      {
        "id": "apply",
        "role": "apply",
        "title": "Add an instruction to the program",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does \"free\" buy you?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "inspect",
        "role": "apply",
        "title": "Read a program without running it",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "monad-transformer",
    "rungs": [
      {
        "id": "apply",
        "role": "apply",
        "title": "Stack Maybe on top of another monad",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Why do transformers exist?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "why",
        "role": "break",
        "title": "Show that the nesting does not chain, then fix it",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "bifunctor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Map over both slots",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "bimap for Either",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Pair<A, B>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The two slots cannot be crossed",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "contravariant-functor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Map over the input instead of the output",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which way does composition go?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Predicate<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The arrow runs before the predicate",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "profunctor",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Adjust both ends of a function",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which end is which?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Fn<A, B>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "One arrow in, one arrow out",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "alternative",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Fall back to the other one",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Try several sources in order",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Maybe<A> with alt",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "alt stays inside, getOrElse leaves",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "foldable",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Fold a tree down to one value",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does Foldable let you write once?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy Tree<A>",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "The seed is what fixes B",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "traversable",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Turn the structure inside out",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "traverse in one pass",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Write sequence over an array of Maybes",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "One Maybe on the outside means one decision",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "morphism",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Objects and arrows",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Classify the arrows",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "classify",
        "role": "apply",
        "title": "Sort functions into the named kinds",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "semigroupoid",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Composition that associates",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Semigroupoid or category?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "no-identity",
        "role": "break",
        "title": "Compose without an identity to fall back on",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "category",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Composition with an identity",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What makes a category?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "check-the-laws",
        "role": "apply",
        "title": "Write the check for what a category requires",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "endomorphism",
    "rungs": [
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which of these are endomorphisms?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "implement",
        "role": "implement",
        "title": "Endomorphisms form a monoid",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "fold-them",
        "role": "apply",
        "title": "Fold a list of endomorphisms into one",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "isomorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A pair of morphisms that undo each other",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What makes it an isomorphism rather than two functions?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "check-it",
        "role": "apply",
        "title": "Write the check that both ways hold",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "homomorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A map that preserves the structure",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which of these are homomorphisms?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "check-it",
        "role": "apply",
        "title": "Write the structure-preserving check",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "natural-transformation",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Change the container, not the contents",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does naturality forbid?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "typed",
        "role": "implement",
        "title": "Satisfy ArrayToMaybe",
        "kind": "code",
        "lang": "ts"
      },
      {
        "id": "typed-read",
        "role": "recognize",
        "title": "A binds on the function, so the elements stay opaque",
        "kind": "expr",
        "lang": "ts"
      }
    ]
  },
  {
    "termId": "catamorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Collapse a structure to a value",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which direction?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "direction",
        "role": "break",
        "title": "Show that the direction matters",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "anamorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "Build a structure from a seed",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "apply",
        "role": "apply",
        "title": "Unfold the digits of a number",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "use-it",
        "role": "apply",
        "title": "Unfold a range and a number's digits",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "hylomorphism",
    "rungs": [
      {
        "id": "apply",
        "role": "apply",
        "title": "Unfold then fold",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Why name it at all?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "throwaway",
        "role": "apply",
        "title": "Count what the middle costs, then remove it",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "paramorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "A fold that can see what is left",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "What does para add?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "use-it",
        "role": "apply",
        "title": "Fold with the rest of the list in hand",
        "kind": "code",
        "lang": "js"
      }
    ]
  },
  {
    "termId": "apomorphism",
    "rungs": [
      {
        "id": "implement",
        "role": "implement",
        "title": "An unfold that can finish early",
        "kind": "code",
        "lang": "js"
      },
      {
        "id": "recognize",
        "role": "recognize",
        "title": "Which unfold is which?",
        "kind": "choice",
        "lang": "js"
      },
      {
        "id": "use-it",
        "role": "apply",
        "title": "Unfold that can hand back the rest and stop",
        "kind": "code",
        "lang": "js"
      }
    ]
  }
];

export const manifestByTerm: Record<string, ManifestEntry> = Object.fromEntries(
  manifest.map((entry) => [entry.termId, entry]),
);

export const manifestTermIds: string[] = manifest.map((entry) => entry.termId);

export const hasExercises = (termId: string): boolean => termId in manifestByTerm;
